import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Quote.scss';

const Quote = ({ content, attrs = {} }) => {
	if (!content) return null;
	const style = {};
	if (attrs.align || attrs.textAlign) style.textAlign = attrs.align || attrs.textAlign;
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.padding) {
		style.padding = attrs.padding.join(' ');
		style.boxSizing = 'border-box';
	}

	return (
		<blockquote className={[s.quote, (attrs.fontWeight && parseInt(attrs.fontWeight, 10) < 400 ? s.quote__light : null)]} style={style}>
			<p className={s.quote_content} dangerouslySetInnerHTML={{ __html: purifier(content.quote.rawText, { ADD_ATTR: ['target'] }) }} />
			{ content.cite && <cite className={s.quote_cite} dangerouslySetInnerHTML={{ __html: purifier(content.cite.rawText, { ADD_ATTR: ['target'] }) }} /> }
		</blockquote>
	);
};

export default hot(module)(Quote);
